<template>
  <v-fade-transition mode="out-in">
    <v-btn
      :key="$vuetify.theme.dark"
      icon
      class="app-bar-icon-button"
      :aria-label="$vuetify.theme.dark ? $t(&quot;Switch to light mode&quot;) : $t(&quot;Switch to dark mode&quot;)"
      @click="$vuetify.theme.dark = !$vuetify.theme.dark"
    >
      <v-icon>{{ $vuetify.theme.dark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}</v-icon>
    </v-btn>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
      },
    }
  },
}
</script>

<style>
</style>
